import { call, put, takeEvery } from 'redux-saga/effects';
import UrlParser from 'utils/parsers/UrlParser';
import { golfApi } from 'config/axios';
import { MaxClubTypeId } from 'Gears/utils/GearGolfUtils';

import {
    FETCH_GOLF_CLUBS,
    FETCH_GOLF_CLUBS_SUCCESS,
    FETCH_GOLF_CLUB_TYPES,
    FETCH_GOLF_CLUB_TYPES_SUCCESS,
    FETCH_GOLF_CLUB_FLEX_TYPES,
    FETCH_GOLF_CLUB_FLEX_TYPES_SUCCESS
} from '../actions/ActionTypes';

// worker
export function* fetchGolfClubs(action) {
    const urlParser = new UrlParser();
    const params = urlParser.convertObjectToQueryString({
        'per-page': 1000,
        'include-stats': action.includeStats,
        maxClubTypeId: MaxClubTypeId
    });

    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/club/player' + params);

        yield put({
            type: FETCH_GOLF_CLUBS_SUCCESS,
            golfClubs: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchGolfClubTypes(action) {
    const urlParser = new UrlParser();
    const query = urlParser.convertObjectToQueryString({
        maxClubTypeId: MaxClubTypeId
    });
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/club/types' + query);

        yield put({
            type: FETCH_GOLF_CLUB_TYPES_SUCCESS,
            golfClubTypes: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchGolfClubFlexTypes(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/club/flex-types');

        yield put({
            type: FETCH_GOLF_CLUB_FLEX_TYPES_SUCCESS,
            golfClubsFlexTypes: response.data
        });
    } catch (e) {
        // handling error
    }
}

// watcher
export const golfClubSagas = [
    takeEvery(FETCH_GOLF_CLUBS, fetchGolfClubs),
    takeEvery(FETCH_GOLF_CLUB_TYPES, fetchGolfClubTypes),
    takeEvery(FETCH_GOLF_CLUB_FLEX_TYPES, fetchGolfClubFlexTypes)
];
